import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { ImageBox } from '../../ui/ImageBox';
import { menuSections } from '../../../data/menu';
import { IMAGES } from '../../../data/images';

/**
 * The whole Fuel Stop menu is short enough to preview in full — four items
 * across three sections — so this shows all of it rather than picking
 * favourites and implying there is more hidden behind the link.
 *
 * Asymmetric on purpose: the photograph carries the appetite and the list
 * carries the facts, so they are not given equal weight.
 */
export function FoodPreview() {
  const items = menuSections.flatMap(section => section.items);
  return <section aria-labelledby="food-preview-heading" className="bg-ink py-16 sm:py-24" data-id="element-237" data-mp="jzapt57cjs5">
      <div className="mx-auto max-w-container px-gutter-sm sm:px-gutter-md lg:px-gutter-lg" data-id="element-238" data-mp="3ipc3gusqqqv3">
        <div className="grid gap-10 lg:grid-cols-[1.1fr_1fr] lg:items-center lg:gap-16" data-id="element-239" data-mp="3nphxuiqeargv">
          <div data-id="element-240" data-mp="1cjs2dfdg7mjt">
            <p className="mb-5 border-l-4 border-flame pl-3 text-sm font-black uppercase tracking-[0.2em] text-flame" data-id="element-241" data-mp="1cjijebqtmfnm">
              The Fuel Stop
            </p>
            <h2 id="food-preview-heading" className="font-bebas text-5xl leading-[0.9] tracking-wide text-cream sm:text-6xl" data-id="element-242" data-mp="17n9zkl1ohya4">
              Refuel properly
            </h2>
            <p className="mt-4 max-w-prose text-lg leading-relaxed text-cream/80" data-id="element-243" data-mp="sw16u32hbwsr">
              Breakfast baps served all day, handmade savoury pies and the
              smashed burger, all cooked at our catering truck out in the car
              park — there every day we're open. Inside it's the lighter end:
              coffee, cakes and the ice cream counter.
            </p>

            <dl className="mt-8 divide-y divide-white/10 border-y border-white/10" data-id="element-244" data-mp="xtazrsp2uqlc">
              {items.map(item => <div key={item.name} className="flex items-baseline gap-3 py-3.5" data-id="element-245" data-mp="5702os0oj7ta">
                  <dt className="font-bold text-cream" data-id="element-246" data-mp="257wt2cdv4mmx">{item.name}</dt>
                  <span aria-hidden="true" className="mx-1 min-w-4 flex-1 translate-y-[-0.2em] border-b border-dotted border-cream/25" data-id="element-247" data-mp="2a71478kckufw" />
                  <dd className="shrink-0 font-bebas text-xl leading-none tracking-wide text-flame" data-id="element-248" data-mp="2jy44471jj3dl">
                    {item.price}
                  </dd>
                </div>)}
            </dl>

            <Link to="/food-and-drink" className="group mt-8 inline-flex items-center gap-2 rounded-container bg-flame px-6 py-3.5 text-sm font-black uppercase tracking-wide text-white transition-colors duration-200 ease-out-expo hover:bg-flame-dark focus:outline-none focus:ring-2 focus:ring-flame focus:ring-offset-2 focus:ring-offset-ink" data-id="element-249" data-mp="1r85dw8bm107c">
              See the full menu
              <ArrowRight className="h-4 w-4 transition-transform duration-200 ease-out-expo group-hover:translate-x-1 motion-reduce:transform-none" aria-hidden="true" data-id="element-250" data-mp="3bngyrbidwmwg" />
            </Link>
          </div>

          <ImageBox src={IMAGES.fuelStopHatch.src} alt={IMAGES.fuelStopHatch.alt} ratio="4/3" className="rounded-container shadow-2xl" data-id="element-251" data-mp="r94u7ol205n2" />
        </div>
      </div>
    </section>;
}